import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SidePanel } from '@alfa-bank/newclick-composite-components/side-panel';
import cn from 'classnames';
import { BottomSheet } from '@alfalab/core-components/bottom-sheet';
import { Gap } from '@alfalab/core-components/gap';
import { Feature } from '../../constants/feature';
import { useWidgetContext } from '../../hooks/use-widget-context';
import { useTitle } from '../side-panel-header/hooks/use-title';
import { BackCall } from './back-call';
import { PhoneInfo } from './phone-info';
import { SocialNetworkInfo } from './socialnetwork-info';
import styles from './index.module.css';
const Component = () => {
    const { hasFeature, isWebview, isPreAuth } = useWidgetContext();
    const showBackCall = hasFeature(Feature.BackCallButton) && !isWebview && !isPreAuth;
    return (_jsxs("div", { "data-test-id": 'other-contacts-component', children: [_jsx(PhoneInfo, {}), showBackCall && _jsx(BackCall, {}), _jsx(Gap, { size: 'l' }), _jsx(SocialNetworkInfo, {})] }));
};
export const OtherContacts = ({ openBottomSheet = false, toggleBottomSheet }) => {
    const { platform, onClose, isWebview, isPreAuth } = useWidgetContext();
    const { title } = useTitle();
    if (platform === 'mobile' && !isWebview && !isPreAuth) {
        return (_jsx(BottomSheet, { open: openBottomSheet, title: title, hasCloser: true, onClose: toggleBottomSheet || onClose, children: _jsx(Component, {}) }));
    }
    return (_jsx(SidePanel.Body, { greed: true, className: cn({ [styles.sidePanelBodyWebview]: isWebview }), children: _jsx(Component, {}) }));
};
